import type { SVGProps } from 'react'
const SvgSyTechSolidCloudStack = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M20.39 18.24V8l-8.87-5.11v4.66l4.85 2.77-.02 5.59z" />
		<path fill="#e9e9e9" d="M14.79 19.86v-8.63L7.33 6.92v4.02l4.01 2.29-.02 4.62z" />
		<path fillOpacity={0.24} d="M9.76 21.15v-7.01l-6.07-3.5V14l3.17 1.81-.02 3.66z" />
	</svg>
)
export default SvgSyTechSolidCloudStack
